import BrowserStorageService from './browserStorageService'

export const USUARIO_LOGADO = '_usuario_logado'
export default class AuthService {

    static isAuthenticated(){
        const usuario = BrowserStorageService.obterItem(USUARIO_LOGADO)
        return Boolean(usuario && usuario.username)
    }

    static removerUsuarioAutenticado(){
        BrowserStorageService.removerItem(USUARIO_LOGADO)
    }

    static logar(usuario){
        BrowserStorageService.adicionarItem(USUARIO_LOGADO,usuario)
    }

    static obterUsuarioAutenticado(){
        return BrowserStorageService.obterItem(USUARIO_LOGADO)
    }

    static hasPerms(perfil){
        let tem = false
        try{
            let perms = this.obterUsuarioAutenticado()
            tem = perms.roles.some(obj => {
                return perfil.some(p => p == obj)
            })
        }catch{
            tem = false
        }
        return tem
    }
}